export const superScriptChars = ['®', '§','TM'];
